// extracted by mini-css-extract-plugin
export default {"root":"IconLinkedin_root__rXn4P"};